import $ from 'jquery';
import branchBar from './modules/branch-bar';
import NavigationHandler from './modules/navigation';
import MegaMenuDropdowns from './modules/megamenu-dropdowns';
import stickyHeader from './modules/sticky-header';
import anchorScroll from './modules/scroll-to';
import searchForm from './modules/search-form';
import bannerVideo from './modules/banner-video';
import LinkWrappers from './modules/link-wrappers';
import accessibleMultiselects from './modules/accessible-multiselects';
import carriages from './modules/carriages';
import newsForm from './modules/news-form';
import scrollToTop from './modules/scroll-to-top';
import RestrictedAccess from './modules/restricted-access'
import FilesizeLimit from './modules/filesize-limit';
import initSimpleVideoPlayer from './modules/initSimpleVideoPlayer';
import share from './modules/share';
import initializeFormSubmitValidation from './modules/form-submit-validation';
import vhCalculation from './modules/vh-calculation';

//Initialize on document ready
$(document).ready(() => {
  branchBar.init();

  //load video module if an iframe found in the page
  if(document.getElementsByTagName('iframe')) {
    import('./modules/video').then(module => {
      module.init();
    });
  }


  if(document.getElementById('vr-alert-ribbon')) {
    import('./modules/notificationBanner').then(module => {
      module.init();
    });
  }


  //Detect touch events
  var $body = $('body');
  if ('ontouchstart' in window || 'ontouch' in window) {
    $body.addClass('touch-device');
  } else {
    $body.addClass('non-touch-device');
  }

  NavigationHandler.init();

  const header = document.querySelector('.header')
  if(header) {
    const megamenuDropdowns = new MegaMenuDropdowns(document.querySelector('.header'), {bodyClass: 'megamenu-open'});
    megamenuDropdowns.init();
    stickyHeader();
  }

  //activate viewport height unit calculation
  vhCalculation();


  anchorScroll.init();
  scrollToTop.init();
  searchForm.init();
  bannerVideo.init();
  const linkWrappers = new LinkWrappers();
  linkWrappers.attachListeners();
  accessibleMultiselects.init();
  carriages.init();
  newsForm.init();
  share.init();
  initializeFormSubmitValidation();


  // Restricted access element
  const restrictedAccessBlock = document.querySelector('.restricted-access-block')
  if ( restrictedAccessBlock ) {
    const restrictedAccess = new RestrictedAccess()
    restrictedAccess.init()
  }

  // form file input filesize limiter
  const fileSizeLimit = document.querySelectorAll('.js-filesize-limit')
  if (fileSizeLimit.length) {
    const limiter = new FilesizeLimit()
    limiter.init()
  }

  //Brand rails visual, show if hero on page
  if($('.hero').length) {
    $('.brand-rails-visual').removeClass('d-none');
  }

  //simple video players (video hero)
  const videoContainers = document.querySelectorAll('.js-video-container');
  if(videoContainers.length) {
    videoContainers.forEach(container => {
      initSimpleVideoPlayer(container, '.js-video-control');
    })
  }
});
